import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import InstallMobileIcon from '@mui/icons-material/InstallMobile';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

const InstallButton: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] =
    useState<BeforeInstallPromptEvent | null>(null);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
      setShowButton(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Hide if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowButton(false);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      setShowButton(false);
    }
    setDeferredPrompt(null);
  };

  if (!showButton) return null;

  return (
    <Button
      variant='outlined'
      size='small'
      startIcon={<InstallMobileIcon sx={{ fontSize: '16px !important' }} />}
      onClick={handleInstall}
      sx={{
        color: 'white',
        borderColor: 'rgba(255,255,255,0.5)',
        whiteSpace: 'nowrap',
        minWidth: 'auto',
        px: { xs: 1, sm: 2 },
        py: 0.5,
        fontSize: { xs: '0.7rem', sm: '0.8rem' },
        '&:hover': {
          borderColor: 'white',
          backgroundColor: 'rgba(255,255,255,0.1)',
        },
      }}
    >
      Install
    </Button>
  );
};

export default InstallButton;
